import { useEffect, useRef } from "react";
import { LuTrash2 } from "react-icons/lu";

interface ProjectDropdownMenuProps {
  projectId: string;
  isOpen: boolean;
  onClose: () => void;
  position: { x: number; y: number };
}

export default function SideMenuProjectDropdownMenu({
  isOpen,
  onClose,
  position,
}: ProjectDropdownMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={menuRef}
      className="absolute bg-[#B4B7CC] dark:bg-[#272A30] text-white
        rounded-lg shadow-lg py-1 z-50 min-w-[180px]"
      style={{
        top: position.y,
        left: position.x,
      }}
      onMouseLeave={onClose}
    >
      <button
        onClick={handleDeleteProject}
        className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-black/10 transition-colors"
      >
        <LuTrash2 size={18} />
        <span>Delete project</span>
      </button>
    </div>
  );

  function handleDeleteProject() {
    onClose();
  }
}
